<template>
    <div class="posts">
        <transition-group name="fade" mode="in-out">
        <div v-for="(post, index) in posts" :key="'post-'+index" class="post">
            <WordsOfWisdomPost :post="post"></WordsOfWisdomPost>
        </div>
        </transition-group>
    </div>
</template>

<script>
import axios from 'axios';
import WordsOfWisdomPost from './components/WordsOfWisdomPost'

export default {
  name: 'WordsOfWisdomSimple',
  data() {
    return {
      posts: []
    }
  },
  props: [
    'limit'
  ],
  components: {
    WordsOfWisdomPost
  },
  mounted() {
    axios.get(`${window.location.origin}/wp-json/wp/v2/posts?_embed&per_page=3`)
    .then(response => {
      this.posts = response.data
    })

  }
}
</script>

<style scoped lang="scss">
.posts {
  padding: 20px;

  @media screen and (min-width: 640px) {
    padding: 0;
  }

  span {
    display: flex;
    flex-wrap: wrap;
  }
}
.post {
  text-align: left;
  flex-basis: 100%;
  font-family: "Circular std book", sans-serif;
  position: relative;
  
  @media screen and (min-width: 640px) {
    flex-basis: 25%;
  }
}
.post:first-of-type {
  flex-basis: 100%;

  @media screen and (min-width: 640px) {
    flex-basis: 50%;
  }
}
.post-content {
  padding: 2em 2em 4em 2em;
}
.post .post__image {
  width: 100%;
  height: 50vw;
  object-fit: cover;

  @media screen and (min-width: 640px) {
    height: 40vw;
  }
  @media screen and (min-width: 1024px) {
    height: 500px;
  }
}
.post-content {
  padding: 2em 2em 4em 2em;
}
.post__image {
  width: 100%;
  height: 315px;
  object-fit: cover;
}
.post__title {
  margin-top: 0;
  margin-bottom: 0.25em;
}
/* .post:first-of-type .post__image {
  width: 800px;
} */
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s ease;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
